import { Box, Flex } from '@chakra-ui/react';
import { Card, CardContent } from '@mesh.ai/rabbit';
import { format } from 'date-fns';
import ColorCodedDate from 'models/common/ColorCodedDate';
import { useHistory } from 'react-router-dom';

import { ArrowBack } from 'assets/assetsV1/iconComponents';

import { Button } from 'uiToolkitV1/Button';
import { TextBodyMedium, TextHeader2, TextLabel } from 'uiToolkitV1/Typography';

type SurveyFormHeaderProps = {
  isPreview: boolean;
  name: string;
  endDateFormatted: ColorCodedDate;
  questionsData: { answerType: string; feedbackText: string | null; selectedAnswerOptions: [] }[];
};

export const SurveyFormHeader = ({ isPreview, name, endDateFormatted, questionsData }: SurveyFormHeaderProps) => {
  const history = useHistory();

  const backClickHandler = () => {
    history.goBack();
  };

  const totalQuestionsCount = questionsData.length;
  const answeredQuestionsCount = questionsData.filter((question) => {
    if ((question.answerType === 'NONE' && question.feedbackText) || question.selectedAnswerOptions.length > 0) {
      return true;
    }
    return false;
  }).length;

  return (
    <Card style={{ height: '80px', padding: '12px' }}>
      <CardContent style={{ height: '100%' }}>
        <Flex h="100%">
          <Flex flex="1" alignItems="center">
            {!isPreview && (
              <Button
                StartIcon={ArrowBack}
                variant="tertiary"
                iconSize="24px"
                onClick={backClickHandler}
                pl="0 !important"
                startIconProps={{ marginLeft: '-4px !important', color: '#666 !important' }}
              />
            )}
            <Box>
              <TextHeader2 bold>{name}</TextHeader2>
              <TextLabel color="text.g2">
                Due Date: {endDateFormatted ? format(new Date(endDateFormatted.timeStamp), 'd MMM yyyy') : ''}
              </TextLabel>
            </Box>
          </Flex>
          <Flex flexDir="column" gap="4px" alignItems="end" justifyContent="center">
            {/* Progress */}
            <Box h="8px" w="100px" borderRadius="12px" bg="neutral.CFD7DF" overflow="hidden">
              <Box
                h="100%"
                w={`${(answeredQuestionsCount / totalQuestionsCount) * 100}%`}
                borderRadius="12px"
                bg="#0D819F"
              />
            </Box>
            <TextBodyMedium>
              {answeredQuestionsCount} of {totalQuestionsCount} answered
            </TextBodyMedium>
          </Flex>
        </Flex>
      </CardContent>
    </Card>
  );
};
